// extracted by mini-css-extract-plugin
module.exports = {"ContactForm":"ContactFormSchool-module--ContactForm--1nnbV","buttonWrapper":"ContactFormSchool-module--buttonWrapper--25qPN","Loader":"ContactFormSchool-module--Loader--1UF4C"};